/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const [isAccount, setIsAccount] = useState<boolean>(false)

  useEffect(() => {
    const isAccount = localStorage.getItem('isAccount')
    if (isAccount === 'true') {
      setIsAccount(true)
    } else {
      setIsAccount(false)
      localStorage.setItem('isAccount', 'false')
    }
  }, [currentUser])

  // console.log("Test Current User: ", JSON.stringify(currentUser))

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'Home'})}
        fontIcon='bi-app-indicator'
      />

      {/* Only show Claim Management if user has view access */}
      {currentUser?.menuAccess?.claim?.view && (
        <SidebarMenuItem to='/builder' icon='book' title='Claim Management' fontIcon='bi-layers' />
      )}

      {/* Notifications */}
      <SidebarMenuItem
        to='/notifications'
        icon='notification'
        title='Notifications'
        fontIcon='bi-bell'
      />

      {/* <SidebarMenuItem
        to='/settlement'
        icon='calculator'
        title='Claim Settlement'
        fontIcon='bi-layers'
      /> */}

      {/* Manual Activation Management */}
      {/* {(currentUser?.roleId === 6 || currentUser?.roleId === 1) && (
        <SidebarMenuItem
          to='/manual-activation'
          icon='lock'
          title='Manual Activation'
          fontIcon='bi-lock'
        />
      )} */}

      {/* Account Management */}
      {(currentUser?.menuAccess?.accountprovider?.view ||
        currentUser?.menuAccess?.accountprovider?.create) && (
        <SidebarMenuItem to='/account' icon='profile-circle' title='Account' fontIcon='bi-person' />
      )}
    </>
  )
}

export {SidebarMenuMain}
